// src/contexts/servicos/OrdemServicoContext.js
import React, { createContext, useCallback, useContext, useMemo, useState } from 'react';
import { useAlert } from '../geral/AlertContext';
import { useMessage } from '../geral/MessageContext';
import * as service from '../../services/servicos/OrdemServicoService';
const OrdemServicoContext = createContext();
export const useOrdemServico = () => useContext(OrdemServicoContext);
export const OrdemServicoProvider = ({
  children
}) => {
  const [loading, setLoading] = useState(false);
  const [ordens, setOrdens] = useState([]);
  const {
    showAlert
  } = useAlert();
  const { showMessage } = useMessage();
  const executar = useCallback(async (acao, sucesso, ocultarErro = false) => {
    setLoading(true);
    try {
      const result = await acao();
      if (sucesso) showAlert(sucesso);
      return result;
    } catch (error) {
      if (!ocultarErro) {
        showMessage(error?.message || 'Não foi possível concluir a operação.', 'danger');
      }
      return null;
    } finally {
      setLoading(false);
    }
  }, [showAlert, showMessage]);
  const listar = useCallback(async filtros => {
    const result = await executar(
      () => service.listarOrdensServico(filtros),
    );
    if (result === null) return null;
    setOrdens(result || []);
    return result || [];
  }, [executar]);
  const value = useMemo(() => ({
    loading,
    ordens,
    listar,
    obter: id => executar(() => service.obterOrdemServico(id)),
    obterDetalhada: id => executar(() => service.obterOrdemServicoDetalhada(id)),
    criar: dados => executar(() => service.criarOrdemServico(dados), 'Ordem de serviço aberta com sucesso.'),
    atualizar: (id, dados) => executar(() => service.atualizarOrdemServico(id, dados), 'Ordem de serviço salva com sucesso.'),
    acao: (id, acao, dados) => executar(
      () => service.executarAcaoOrdemServico(id, acao, dados),
      'Situação da ordem atualizada.',
      acao === 'faturar',
    ),
    aprovar: (id, dados) => executar(() => service.aprovarOrdemServico(id, dados), 'Orçamento aprovado com sucesso.'),
    prepararFaturamento: ids => executar(
      () => service.prepararFaturamentoOrdensServico(ids),
    ),
    faturarLote: dados => executar(
      () => service.faturarOrdensServicoLote(dados),
      'Ordens de serviço faturadas com sucesso.',
    ),
    enviarDocumentosWhatsApp: ids => executar(
      () => service.enviarDocumentosFiscaisWhatsApp(ids),
      'Documentos fiscais adicionados à fila de envio do WhatsApp.',
    ),
  }), [loading, ordens, listar, executar]);
  return <OrdemServicoContext.Provider value={value}>{children}</OrdemServicoContext.Provider>;
};
